<div class="w-full p-8 pb-0 flex  justify-end">
    <button (click)="closeDialog()"><i class="fa-light fa-xmark text-3xl text-white"></i></button>
</div>
<div class="flex flex-col items-center p-8 pb-4">
    <p class="text-white text-2xl">Esta acción te redirigirá a una página y perderás los cambios</p>
    <p class="text-white text-2xl pb-4">¿Seguro que quieres crear un perfil?</p>
    <button
        class="rounded-button bg-accent w-48 h-13 border border-tertiary cursor-pointer text-quaternary text-lg mr-9"
        (click)="goTo('/perfiles')">
        Aceptar
    </button>
</div>
